import React from "react";
import { addOnOrderAnalysis } from "../../../Action/courseAction";
import { OrderDayPage, countOf, pctOf } from "../../Common/orderAnalysisCommon";


const AddOnAnalysis = () => (
  <OrderDayPage
    pageTitle="Add On Analysis"
    tableId="add-on-analysis"
    fetchAction={addOnOrderAnalysis} // { startDate, endDate, examSectionId?, examSubSectionId? } — same as before
    parse={(res) => ({ rows: res?.data?.orderData, summary: res?.data?.totalSummary })}
    dateKey="orderDate"
    columns={[
      { key: "addOnRatio", header: "Add On Ratio", kind: "pct" },
      { key: "dayConversion", header: "Day Conversion", kind: "pct" },
      { key: "totalAddOnCount", header: "Total Add On Count", kind: "count" },
      { key: "totalCartDetails", header: "Total Cart Count", kind: "list", listTitle: "Total Cart Details" },
      { key: "totalCourses", header: "Total Courses", kind: "count" },
      { key: "totalOrders", header: "Total Orders", kind: "count" },
      { key: "totalPopUpDetails", header: "Total PopUp Details", kind: "list", listTitle: "Total Pop Up Details" },
      { key: "upgradeOptionFalseDetails", header: "Upgrade Option False Details", kind: "list", minWidth: 150 },
    ]}
    summaryGroups={(s) => [
      {
        title: "Total",
        tone: "primary",
        metrics: [
          { label: "Orders", value: countOf(s.totalOrders) },
          { label: "Courses", value: countOf(s.totalCourses) },
          { label: "Day Conversion", value: pctOf(s.dayConversion) },
        ],
      },
      {
        title: "Add On",
        tone: "pink",
        metrics: [
          { label: "Pop Up", value: countOf(s.totalPopUpCount) },
          { label: "Add On", value: countOf(s.totalAddOnCount) },
          { label: "Add On Ratio", value: pctOf(s.addOnRatio) },
        ],
      },
      { title: "Cart", tone: "warning", metrics: [{ label: "Cart Count", value: countOf(s.totalCartCount) }] },
    ]}
  />
);

export default AddOnAnalysis;
